import React, { useEffect, useState } from 'react';
import FinishModal from '../FinishModal';
import { FALLBACK_URL, REDIRECT_INTERVAL } from '../../hooks/useLoanForm';
import { CommonProps } from '../../layout/LoanForm';

const ThankYouPage = ({
  t,
  statusUrl,
}: CommonProps & {
  statusUrl: string;
}) => {
  const [openFinishModal, setOpenFinishModal] = useState<boolean>(false);
  console.log('🚀 ~ statusUrl:', statusUrl);

  useEffect(() => {
    setOpenFinishModal(true);
    const interval = REDIRECT_INTERVAL * 1000;

    if (!statusUrl) {
      return;
    }

    const checkLoanRequest = async () => {
      try {
        const response = await fetch(statusUrl);
        const { next_request_status, redirect_url } = await response.json();

        if (next_request_status == 'stop' && redirect_url) {
          window.location.replace(redirect_url);
        } else if (redirect_url) {
          window.location.replace(redirect_url);
          clearInterval(checkLoanInterval);
        } else {
          window.location.replace(FALLBACK_URL);
          clearInterval(checkLoanInterval);
        }
      } catch (error) {
        console.error(error);
        window.location.replace(FALLBACK_URL);
        clearInterval(checkLoanInterval);
      }
    };

    const checkLoanInterval = setTimeout(checkLoanRequest, interval);

    return () => {
      clearInterval(checkLoanInterval);
    };
  }, [statusUrl]);

  return (
    <div>
      <FinishModal t={t} open={openFinishModal} />
    </div>
  );
};

export default ThankYouPage;
